import React from "react"
import { Link } from "gatsby"

import MainLayout from "../components/layout"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../components/SubPages/GridViewSubPages/gridViewSubPages"
import SideImageContent from "../components/SubPages/AboutUsPage/sideImageContent"

import Constants from "../constants/aboutUs.json"

import backgroundImg from "../images/aboutus/background.svg"
import expertsImg from "../images/aboutus/Expert team.png"
import Scalable from "../images/aboutus/Scalable.png"
import Secure from "../images/aboutus/Secure.png"
import Innovative from "../images/aboutus/Innovative.png"

const GridData = [
  {
    title: Constants.grid.item1.title,
    description: Constants.grid.item1.description,
    img: expertsImg,
  },
  {
    title: Constants.grid.item2.title,
    description: Constants.grid.item2.description,
    img: Scalable,
  },
  {
    title: Constants.grid.item3.title,
    description: Constants.grid.item3.description,
    img: Secure,
  },
  {
    title: Constants.grid.item4.title,
    description: Constants.grid.item4.description,
    img: Innovative,
  },
]

const AboutUsPage = () => (
  <MainLayout>
    <SEO
      title="AboutUs"
      description="Real time communication with Meetrix Build a secure bridge between the business and the client with real-time communication"
      pagePath="/aboutus"
      schema={`{
              "@context": "https://meetrix.io/aboutus",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.intro.title}
      description={Constants.intro.description}
      background={backgroundImg}
      blueTitle="Contact Us"
    />
    <SideImageContent />
    <GridView twoCol data={GridData} noButton noHeader />
  </MainLayout>
)

export default AboutUsPage
